import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {ApplicationInsightsService} from './application-insights.service';

/**
 * Global error handler that forwards exceptions to Application Insights.
 */
@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService extends ErrorHandler {

  constructor(private injector: Injector) {
    super();
  }

  /**
   * Captures the error and tracks it with Application Insights, then rethrows.
   */
  handleError(error: any) {
    const appInsightService = this.injector.get(ApplicationInsightsService);
    if (appInsightService.appInsights != null) {
      appInsightService.appInsights.trackException({exception: error});
    }
    super.handleError(error);
  }

}
